var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C31.0457 6.18487e-06 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C6.18486e-06 8.95431 8.95431 0 20 0ZM13.624 12.2891C10.9717 12.2891 8.82129 14.4394 8.82129 17.0918V22.8066C8.82129 25.459 10.9717 27.6094 13.624 27.6094H25.9053C28.5575 27.6092 30.708 25.4589 30.708 22.8066V17.0918C30.708 14.4396 28.5575 12.2892 25.9053 12.2891H13.624ZM17.0283 17.2246C17.0283 16.9758 17.7677 16.8198 17.9844 16.9424L23.2568 19.8115C23.4769 19.9374 23.709 20.2565 23.4854 20.377L17.9775 23.1025C17.7608 23.2183 17.0283 23.0621 17.0283 22.8174V17.2246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.2e0b83c91b4807978a578ad30741f3c5.svg";
export { ForwardRef as ReactComponent };